<template>
    <div class="container" id="loginForm">
        <div class="row justify-content-md-center">
            <div class="col-md-8">
                <div class="card">
                    <div class="card-body">
                        <h4>Login</h4>
                        <form>
                            <div class="form-group">
                                <input type="text" v-model="username" placeholder="Username/E-Mail" class="form-control">
                            </div>
                            <div class="form-group">
                                <input type="password" v-model="password" placeholder="Password" class="form-control">
                            </div>
                            
                            <button class="btn btn-primary" @click.prevent="login()">Login</button>
                        </form>
                        <hr>
                        <p>Not registered? <router-link to="/register">Create your Account now!</router-link> | <router-link :to="{name:'ForgotPassword'}">Forgot Password?</router-link></p>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>


    export default {
        name: 'LoginForm',
        props: ['redirect'],
        data(){
            return {
                username: '',
                password: ''
            }
        },
        created() {},
        methods: {
            login(){
                this.$api.login(this.username, this.password)
                  .then((res) => {
                    return this.$store.dispatch('user/init', res.data.token);
                  })
                  .then((res) => {
                    this.$bus.$emit('success', 'Logged in!');
                    if(this.redirect) this.$router.push({name: this.redirect});
                })
            }
        },
        components:{

        }

    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/components/user/LoginForm.vue